import { Drawer } from '@/components';
import styles from './AccessibleVersion.styles'
import { BetaTag } from '@/components';

interface Props {
  wcagHtml?: string;
  isOpen: boolean;
  onToggle: (state: boolean) => void;
}

export const AccessibleVersion: React.FC<Props> = ({
  wcagHtml,
  isOpen,
  onToggle
}) => (
  <Drawer title={<BetaTag />} isOpen={isOpen} onToggle={onToggle} full>
    <div className={styles.container}>
      {wcagHtml && (
        <div className="accessible-content" dangerouslySetInnerHTML={{ __html: wcagHtml }} />
      )}
    </div>
  </Drawer>
);
